<template>
    <span>
        <span v-show="Math.abs(signal)<=wifi_forte_attenuation && !disabled" class="icon has-text-success">
            <i class="fas fa-wifi"></i>
        </span>
        <span v-show="Math.abs(signal)>wifi_forte_attenuation && !disabled" class="icon has-text-warning">
            <i class="fas fa-wifi"></i>
        </span>
        <span v-show=disabled class="icon has-text-grey-lighter">
            <i class="fas fa-wifi"></i>
        </span>
    </span>
</template>

<script>
export default {
    props: {
        signal: Number,
        disabled : {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            wifi_forte_attenuation: 70,
        }
    }
}
</script>

<style scoped>
span {
    line-height: 1em;
}
</style>